import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { getApi } from '../api'

export type CreateAccountShipmentVariables = {
  accountId: number
  /** Engine API v2 nested body (stops, device_ids, … — no routes; use postAccountShipmentRouteSegment per leg). */
  payload: Record<string, unknown>
}

/**
 * Creates a shipment via Engine API v2 (nested stops only; routes are separate POSTs).
 */
export default function createAccountShipment() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ accountId, payload }: CreateAccountShipmentVariables) => {
      const { api, baseURL } = getApi()
      const res = await api.post(`/api/v2/accounts/${accountId}/shipments`, payload, {
        baseURL,
        params: { include: 'stops' },
      })
      return res.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-shipments'] })
      queryClient.invalidateQueries({ queryKey: ['account-shipment-metrics'] })
    },
  })
}
